function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Node, mergeAttributes, textblockTypeInputRule } from '@tiptap/core';
import { Plugin, PluginKey, TextSelection } from '@tiptap/pm/state';
var backtickInputRegex = /^```([a-z]+)?[\s\n]$/;
var tildeInputRegex = /^~~~([a-z]+)?[\s\n]$/;
var CodeBlock = Node.create({
  name: 'codeBlock',
  addOptions: function addOptions() {
    return {
      languageClassPrefix: 'language-',
      exitOnTripleEnter: true,
      exitOnArrowDown: true,
      HTMLAttributes: {}
    };
  },
  content: 'text*',
  marks: '',
  group: 'block',
  code: true,
  defining: true,
  addAttributes: function addAttributes() {
    var _this = this;

    return {
      language: {
        default: null,
        parseHTML: function parseHTML(element) {
          var _a;

          var languageClassPrefix = _this.options.languageClassPrefix;

          var classNames = _toConsumableArray(((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList) || []);

          var languages = classNames.filter(function (className) {
            return className.startsWith(languageClassPrefix);
          }).map(function (className) {
            return className.replace(languageClassPrefix, '');
          });
          var language = languages[0];

          if (!language) {
            return null;
          }

          return language;
        },
        rendered: false
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'pre',
      preserveWhitespace: 'full'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var node = _ref.node,
        HTMLAttributes = _ref.HTMLAttributes;
    return ['pre', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), ['code', {
      class: node.attrs.language ? this.options.languageClassPrefix + node.attrs.language : null
    }, 0]];
  },
  addCommands: function addCommands() {
    var _this2 = this;

    return {
      setCodeBlock: function setCodeBlock(attributes) {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.setNode(_this2.name, attributes);
        };
      },
      toggleCodeBlock: function toggleCodeBlock(attributes) {
        return function (_ref3) {
          var commands = _ref3.commands;
          return commands.toggleNode(_this2.name, 'paragraph', attributes);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this3 = this;

    return {
      'Mod-Alt-c': function ModAltC() {
        return _this3.editor.commands.toggleCodeBlock();
      },
      // remove code block when at start of document or code block is empty
      Backspace: function Backspace() {
        var _this3$editor$state$s = _this3.editor.state.selection,
            empty = _this3$editor$state$s.empty,
            $anchor = _this3$editor$state$s.$anchor;
        var isAtStart = $anchor.pos === 1;

        if (!empty || $anchor.parent.type.name !== _this3.name) {
          return false;
        }

        if (isAtStart || !$anchor.parent.textContent.length) {
          return _this3.editor.commands.clearNodes();
        }

        return false;
      },
      // exit node on triple enter
      Enter: function Enter(_ref4) {
        var editor = _ref4.editor;

        if (!_this3.options.exitOnTripleEnter) {
          return false;
        }

        var state = editor.state;
        var selection = state.selection;
        var $from = selection.$from,
            empty = selection.empty;

        if (!empty || $from.parent.type !== _this3.type) {
          return false;
        }

        var isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
        var endsWithDoubleNewline = $from.parent.textContent.endsWith('\n\n');

        if (!isAtEnd || !endsWithDoubleNewline) {
          return false;
        }

        return editor.chain().command(function (_ref5) {
          var tr = _ref5.tr;
          tr.delete($from.pos - 2, $from.pos);
          return true;
        }).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: function ArrowDown(_ref6) {
        var editor = _ref6.editor;

        if (!_this3.options.exitOnArrowDown) {
          return false;
        }

        var state = editor.state;
        var selection = state.selection,
            doc = state.doc;
        var $from = selection.$from,
            empty = selection.empty;

        if (!empty || $from.parent.type !== _this3.type) {
          return false;
        }

        var isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;

        if (!isAtEnd) {
          return false;
        }

        var after = $from.after();

        if (after === undefined) {
          return false;
        }

        var nodeAfter = doc.nodeAt(after);

        if (nodeAfter) {
          return false;
        }

        return editor.commands.exitCode();
      }
    };
  },
  addInputRules: function addInputRules() {
    return [textblockTypeInputRule({
      find: backtickInputRegex,
      type: this.type,
      getAttributes: function getAttributes(match) {
        return {
          language: match[1]
        };
      }
    }), textblockTypeInputRule({
      find: tildeInputRegex,
      type: this.type,
      getAttributes: function getAttributes(match) {
        return {
          language: match[1]
        };
      }
    })];
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this4 = this;

    return [// this plugin creates a code block for pasted content from VS Code
    // we can also detect the copied code language
    new Plugin({
      key: new PluginKey('codeBlockVSCodeHandler'),
      props: {
        handlePaste: function handlePaste(view, event) {
          if (!event.clipboardData) {
            return false;
          } // don’t create a new code block within code blocks


          if (_this4.editor.isActive(_this4.type.name)) {
            return false;
          }

          var text = event.clipboardData.getData('text/plain');
          var vscode = event.clipboardData.getData('vscode-editor-data');
          var vscodeData = vscode ? JSON.parse(vscode) : undefined;
          var language = vscodeData === null || vscodeData === void 0 ? void 0 : vscodeData.mode;

          if (!text || !language) {
            return false;
          }

          var tr = view.state.tr; // create an empty code block

          tr.replaceSelectionWith(_this4.type.create({
            language: language
          })); // put cursor inside the newly created code block

          tr.setSelection(TextSelection.near(tr.doc.resolve(Math.max(0, tr.selection.from - 2)))); // add text to code block
          // strip carriage return chars from text pasted as code
          // see: https://github.com/ProseMirror/prosemirror-view/commit/a50a6bcceb4ce52ac8fcc6162488d8875613aacd

          tr.insertText(text.replace(/\r\n?/g, '\n')); // store meta information
          // this is useful for other plugins that depends on the paste event
          // like the paste rule plugin

          tr.setMeta('paste', true);
          view.dispatch(tr);
          return true;
        }
      }
    })];
  }
});
export { CodeBlock, backtickInputRegex, CodeBlock as default, tildeInputRegex };